import { useSelector } from 'react-redux';
import { NetworkGood, NetworkBad, NetworkWarning } from './';
import { Dialog, DialogContent } from '@mui/material';

function NetworkStatusDialog({ children }) {
  const { connection } = useSelector((state) => state.status);

  const networkMapper = {
    good: <NetworkGood />,
    bad: <NetworkBad />,
    warning: <NetworkWarning />,
  };

  return (
    <Dialog open={!!connection} disableEscapeKeyDown>
      <DialogContent>
        {networkMapper[connection]}
        {children}
      </DialogContent>
    </Dialog>
  );
}

export default NetworkStatusDialog;
